export * from './tips.mocks';
